exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-document-modal table{line-height:4}.link-document-modal .v-text-field__details{display:none!important;position:absolute!important}.linked-document_table{font-weight:600!important;font-size:12px!important;height:50%!important;padding-bottom:5px!important}.add-link_button{width:100%;font-size:11px}", ""]);

// exports
